import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { TokenLoginRequestDto, TokenServiceClient } from '../../../../web-api-client';
import { AuthModel } from '../../_models/auth.model';
import { UserModel } from '../../_models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(
    private http: HttpClient,
    private tokenServiceClient: TokenServiceClient
  ) { }

  // public methods
  login(email: string, password: string): Observable<any> {
    const request = new TokenLoginRequestDto({ username: email, password });

    return this.tokenServiceClient
      .login(request)
      .pipe(
        map((response) => {
          const token = response?.data?.token;
          if (!response?.succeeded || !token) {
            throw new Error(response?.data?.message || 'Login failed.');
          }

          const auth = new AuthModel();
          auth.authToken = token;
          auth.refreshToken = token;
          auth.expiresIn = new Date(Date.now() + 30 * 60 * 1000);

          return auth;
        })
      );
  }

  // CREATE =>  POST: add a new user to the server
  createUser(user: UserModel): Observable<UserModel> {
    return this.http.post<UserModel>(`${environment.apiUrl}/auth`, user);
  }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiUrl}/auth/forgot-password`, {
      email,
    });
  }

  getUserByToken(token): Observable<UserModel> {
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<UserModel>(`${environment.apiUrl}/auth/me`, {
      headers: httpHeaders,
    });
  }
}
